import RequestHandlingStep from './RequestHandlingStep.vue'
import { requestHandlingDescriptor } from './descriptor'
import { createRequestHandlingController } from './request-handling-controller'
import { createRequestHandlingReviewContribution } from './review-contribution'

const requestHandlingStepImplementation = Object.freeze({
    descriptor: requestHandlingDescriptor,
    component: RequestHandlingStep,
    createController: createRequestHandlingController,
    createReviewContribution: createRequestHandlingReviewContribution,
})

export {
    RequestHandlingStep,
    createRequestHandlingController,
    createRequestHandlingReviewContribution,
    requestHandlingDescriptor,
    requestHandlingStepImplementation,
}
